import { render, staticRenderFns } from "./decline-claim.vue?vue&type=template&id=f8470694&"
import script from "./decline-claim.vue?vue&type=script&lang=js&"
export * from "./decline-claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports